import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Confirmar", -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "ant-row" }
const _hoisted_4 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }
const _hoisted_5 = {
  key: 0,
  class: "ant-col ant-col-xs-20 ant-col-xl-20"
}
const _hoisted_6 = {
  key: 1,
  class: "ant-col ant-col-xs-20 ant-col-xl-20"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_selecionar_tipo_item_cenario_fiscal = _resolveComponent("selecionar-tipo-item-cenario-fiscal")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_produto = _resolveComponent("selecionar-produto")!
  const _component_selecionar_ncm = _resolveComponent("selecionar-ncm")!
  const _component_card = _resolveComponent("card")!
  const _component_cenario_fiscal_definicao_ipi = _resolveComponent("cenario-fiscal-definicao-ipi")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    centered: "",
    width: 1100,
    "wrap-class-name": "scroll-modal ss-modal-tributacoes",
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event))
  }, {
    title: _withCtx(() => [
      _createTextVNode("Adicionar Exceção de IPI")
    ]),
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.salvar && _ctx.salvar(...args)))
      }, _hoisted_2)
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_form, { layout: "vertical" }, {
        default: _withCtx(() => [
          _createVNode(_component_card, { titulo: "DETALHES DA EXCEÇÃO" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_a_form_item, {
                    label: "Tipo de Exceção",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_selecionar_tipo_item_cenario_fiscal, {
                        valor: _ctx.state.definicao.tipoItem,
                        "onUpdate:valor": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.definicao.tipoItem) = $event))
                      }, null, 8, ["valor"])
                    ]),
                    _: 1
                  })
                ]),
                (_ctx.state.definicao.tipoItem === _ctx.ETipoItemCenarioFiscal.Produto)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      (_ctx.props.definicao.codigo !== -1)
                        ? (_openBlock(), _createBlock(_component_a_form_item, {
                            key: 0,
                            label: "Produto",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_produto, {
                                "modo-definicao-produto": true,
                                empresas: [_ctx.props.empresa],
                                apresentarCodigoInterno: true,
                                "codigo-selecionado": _ctx.state.definicao.codigoProdutoDefinicao,
                                "onUpdate:codigoSelecionado": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.definicao.codigoProdutoDefinicao) = $event)),
                                "codigo-interno-selecionado": _ctx.state.definicao.codigoInternoProduto,
                                "onUpdate:codigoInternoSelecionado": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.definicao.codigoInternoProduto) = $event)),
                                "descricao-selecionado": _ctx.state.definicao.descricaoProduto,
                                "onUpdate:descricaoSelecionado": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.definicao.descricaoProduto) = $event))
                              }, null, 8, ["empresas", "codigo-selecionado", "codigo-interno-selecionado", "descricao-selecionado"])
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_a_form_item, {
                            key: 1,
                            label: "Produtos",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_produto, {
                                "modo-definicao-produto": true,
                                varios: true,
                                empresas: [_ctx.props.empresa],
                                apresentarCodigoInterno: true,
                                "codigos-selecionados": _ctx.state.definicao.codigosDefinicoesProdutos,
                                "onUpdate:codigosSelecionados": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.definicao.codigosDefinicoesProdutos) = $event)),
                                "codigos-internos-selecionados": _ctx.state.definicao.codigosInternosProdutos,
                                "onUpdate:codigosInternosSelecionados": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.definicao.codigosInternosProdutos) = $event)),
                                "descricoes-selecionadas": _ctx.state.definicao.descricoesProdutos,
                                "onUpdate:descricoesSelecionadas": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.definicao.descricoesProdutos) = $event))
                              }, null, 8, ["empresas", "codigos-selecionados", "codigos-internos-selecionados", "descricoes-selecionadas"])
                            ]),
                            _: 1
                          }))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      (_ctx.props.definicao.codigo !== -1)
                        ? (_openBlock(), _createBlock(_component_a_form_item, {
                            key: 0,
                            label: "NCM",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_ncm, {
                                "codigo-selecionado": _ctx.state.definicao.codigoNcm,
                                "onUpdate:codigoSelecionado": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.definicao.codigoNcm) = $event)),
                                descricaoSelecionada: _ctx.state.definicao.descricaoNcm,
                                "onUpdate:descricaoSelecionada": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.definicao.descricaoNcm) = $event)),
                                "ncm-selecionado": _ctx.state.definicao.ncm,
                                "onUpdate:ncmSelecionado": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.definicao.ncm) = $event))
                              }, null, 8, ["codigo-selecionado", "descricaoSelecionada", "ncm-selecionado"])
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_a_form_item, {
                            key: 1,
                            label: "NCMs",
                            class: "ss-margin-campos"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_selecionar_ncm, {
                                varios: true,
                                "codigos-selecionados": _ctx.state.definicao.codigosNcms,
                                "onUpdate:codigosSelecionados": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.definicao.codigosNcms) = $event)),
                                "descricoes-selecionadas": _ctx.state.definicao.descricoesNcms,
                                "onUpdate:descricoesSelecionadas": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.definicao.descricoesNcms) = $event)),
                                "ncms-selecionados": _ctx.state.definicao.ncms,
                                "onUpdate:ncmsSelecionados": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.definicao.ncms) = $event))
                              }, null, 8, ["codigos-selecionados", "descricoes-selecionadas", "ncms-selecionados"])
                            ]),
                            _: 1
                          }))
                    ]))
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_card, { titulo: "DEFINIÇÃO DO IPI" }, {
            default: _withCtx(() => [
              _createVNode(_component_cenario_fiscal_definicao_ipi, {
                definicao: _ctx.state.definicao,
                "onUpdate:definicao": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.definicao) = $event))
              }, null, 8, ["definicao"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["visible"]))
}